import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Contactpage from "../../components/Contactpage/Contactpage";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.png";
// import Footer2 from "../../components/footer2/Footer2";
import Footer from "../../components/footer/Footer";
import pageBanner from "../../images/contactusPageBanner.png";

const ContactPage = () => {
  return (
    <Fragment>
      <Navbar3 Logo={Logo} topbarNone={'wpo-header-style-6'}/>
      <PageTitle
        pageTitle={"Get In touch"}
        pageSub={
          "We will develop top-notch, engaging content and design a journey map to highlight accomplishments."
        }
        backgroundImage={pageBanner}
      />
      <Contactpage />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ContactPage;
